import React, { useState, useEffect } from "react";
import { getStockDetails } from "../service/inventoryService";

const StockDetails = () => {
  const lsUserVO = process.env.REACT_APP_LS_USER_VO;
  const pimsUserVO = JSON.parse(localStorage.getItem(lsUserVO));
  const [stockDetails, setStockDetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  const fetchStockDetails = async () => {
    try {
      const stockDetails = await getStockDetails(pimsUserVO.branchId);
      setStockDetails(stockDetails);
    } catch (error) {
      console.error("Error fetching sales orders:", error);
    }
  };

  useEffect(() => {
    fetchStockDetails();
  }, []);


  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);
  };

  const filteredStockDetails = stockDetails.filter((item) =>
    item.medName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortedStockDetails = [...filteredStockDetails].sort((a, b) => {
    if (sortField) {
      if (typeof a[sortField] === "string") {
        return sortOrder === "asc"
          ? a[sortField].localeCompare(b[sortField])
          : b[sortField].localeCompare(a[sortField]);
      } else {
        return sortOrder === "asc" ? a[sortField] - b[sortField] : b[sortField] - a[sortField];
      }
    }
    return 0;
  });

  return (
    <div className="container mx-auto p-4 sm:p-8">
      <div className="max-w-4xl mx-auto bg-green-200 p-6 sm:p-8 rounded-md shadow-md">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Stock Details</h2>
        <div className="mb-4 sm:mb-6">
          <input
            type="text"
            placeholder="Search by medicine name"
            value={searchQuery}
            onChange={handleSearch}
            className="p-2 border border-gray-300 rounded-md w-full"
          />
        </div>
        <div className="overflow-x-auto">
          {sortedStockDetails.length > 0 ? (
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr>
                  <th className="border p-2 sm:p-3 text-left cursor-pointer border-gray-400" onClick={() => handleSort("medName")}>
                    Medicine Name {sortField === "medName" && (sortOrder === "asc" ? "▲" : "▼")}
                  </th>
                  <th className="border p-2 sm:p-3 text-left cursor-pointer border-gray-400" onClick={() => handleSort("totalPurchaseQty")}>
                    Total Purchase Qty {sortField === "totalPurchaseQty" && (sortOrder === "asc" ? "▲" : "▼")}
                  </th>
                  <th className="border p-2 sm:p-3 text-left cursor-pointer border-gray-400" onClick={() => handleSort("totalSalesQty")}>
                    Total Sales Qty {sortField === "totalSalesQty" && (sortOrder === "asc" ? "▲" : "▼")}
                  </th>
                  <th className="border p-2 sm:p-3 text-left cursor-pointer border-gray-400" onClick={() => handleSort("availableQty")}>
                    Available Qty {sortField === "availableQty" && (sortOrder === "asc" ? "▲" : "▼")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedStockDetails.map((item, index) => (
                  <tr key={index}>
                    <td className="border p-2 sm:p-3 border-gray-400">{item.medName}</td>
                    <td className="border p-2 sm:p-3 border-gray-400">{item.totalPurchaseQty}</td>
                    <td className="border p-2 sm:p-3 border-gray-400">{item.totalSalesQty}</td>
                    <td className="border p-2 sm:p-3 border-gray-400">{item.availableQty}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-lg text-gray-600">No data found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StockDetails;
